export interface GatewaySessionTokenState {
  token: string;
  loaded: boolean;
  loading: boolean;
  errorLoading: boolean;
}

export const initialState: GatewaySessionTokenState = {
  token: '',
  loaded: false,
  loading: false,
  errorLoading: false,
};
